import { DefaultOptionType } from "antd/es/select";
import { Dayjs } from "dayjs";
import { FilterSelectOption } from "../../filters/filters.types";

export interface IInformacijeZaVracanjeDozvole {
  kategorijaProizvodaId: number | null;
  tipObveznikaIds: number[];
}

export interface IDokumentiZaDozvoluProps {
  dozvolaDocumentType: number | null;
  // condition: boolean;
  data: string | ArrayBuffer | null | undefined;
  format: string;
}

export interface IDokumentZaDozvoluForFilter extends IDokumentiZaDozvoluProps {
  uid: string;
  fileSize?: number;
}

export interface IDozvolaInformacijeProps {
  kategorijaProizvodaId: number | null;
  ulicaProizvodnje: string;
  brojUliceProizvodnje: string;
  postanskiBrojProizvodnje: string;
  mestoProizvodnje: string;
  nacinOtpremanja: string;
  podatakOMernimUredjajima: string;
  brojResenja: string;
  datumResenjaNadleznogOrgana: any;

  // Not duvan
  prosecanMesecniRashod: number | null;
  kolicinaUskladistenihProizvoda: number | null;

  // Duvan
  kolicinaDuvanaKg: number | null;
  kolicinaPojedinacnihPakovanjaKomadi: number | null;

  prosecnaKolicinaDuvanaKg: number | null;
  prosecnaKolicinaPojedinacnihPakovanjaKomadi: number | null;

  // Nafta
  tarifnaOznaka: string;
}

export interface IZahtevDozvole {
  tipDozvole: DozvolaTipObjekta | null;
  dokumentiZaDozvolu: IDokumentiZaDozvoluProps[];
  dozvolaInformacije: Partial<IDozvolaInformacijeProps>;
  skladisteInformacije: Partial<ISkladisteInformacijeProps>;
}

export interface IZahtevDozvoleEdit extends IZahtevDozvole {
  dozvolaZahtevId: number | null;
}

export interface ITipObveznika {
  tipObveznikaId: number | null;
  imeTipaObveznika: string;
}

export interface IKategorijeProizvodaProps {
  idKategorijeProizvoda: number | null;
  imeKategorijeProizvoda: string;
  tipObveznika: ITipObveznika[];
}

export interface IListaKategorijeIVrsteObveznikaZaDozvoluProps {
  kategorijaProizvoda: IKategorijeProizvodaProps[];
}

export interface IAkcizniProizvodProps {
  kategorijeProizvodaId: number | null;
  kategorijeProizvodaIme: string;
  isActive: boolean;
}

export interface IUserInformationDozvolaProps {
  akcizniProizvod: IAkcizniProizvodProps[];
  id: number | null;
  naziv: string;
  imeGrada: string;
  pib: string;
  preteznaDelatnost: string;
}

export interface ISkladisteInformacijeProps {
  skladisteId: number | null | undefined;
  kolicinaProizvodaIzPrethodneGodine: number | null | undefined;
  planiranaProizvodnjaProizvoda: number | null | undefined;
  brojSkladistaZaDozvolu: string | undefined;
  ulicaSkladista: string | undefined;
  brojUliceSkladista: string | undefined;
  postanskiBrojSkladista: string | undefined;
  mestoSkladista: string | undefined;
  oznakaSkladista: string | undefined;
  opisSkladista: string | undefined;
  opisRadaRacunovodstva: string | undefined;
  meraVelicineSkladista: number | null | undefined;
  meraVrednost: number | null | undefined;

  // Duvan
  planiranaProizvodnjaProizvodaKg: number | null | undefined;
  kolicinaProizvodaIzPrethodneGodineKg: number | null | undefined;
  kolicinaProizvodaIzPrethodneGodineKomadi: number | null | undefined;
  planiranaProizvodnjaProizvodaKomadi: number | null | undefined;
}

export interface IMereVelicineProps {
  meraIme: string;
  meraId: number | null;
}

export interface IDozvolaInformacijeSkladistaProps {
  tarifnaOznaka: string;
  kategorijaProizvodaId: number | null;
  ulicaProizvodnje: string;
  brojUliceProizvodnje: string;
  postanskiBrojProizvodnje: string;
  mestoProizvodnje: string;
  nacinOtpremanja: string;
  podatakOMernimUredjajima: string;
  brojResenja: string;
  datumResenjaNadleznogOrgana: string;
  datumResenjaNadleznogOrganaPrikaz: string;
  evidencioniBroj: string | null;
  kolicinaUskladistenihProizvoda: number | null;
  kolicinaDuvanaKg: number | null;
  kolicinaPojedinacnihPakovanjaKomadi: number | null;
  prosecnaKolicinaPojedinacnihPakovanjaKomadi: number | null;
  prosecnaKolicinaDuvanaKg: number | null;
  prosecanMesecniRashod: number | null;
}

export interface IDokumentiZaDozvoluSkladistaProps {
  id: number | null;
  tip: number | null;
  dokumentUrl: string;
  vrednostUslova: null;
}

export interface IVracanjeDodatnihInformacijaZaKreiranjeDozvoleProps {
  dozvolaInformacije: IDozvolaInformacijeSkladistaProps;
  userInformationDozvola: IUserInformationDozvolaProps;
  skladisteInformacije: ISkladisteInformacijeProps[];
  mereVelicine: IMereVelicineProps[];
  dokumentiZaDozvolu: IDokumentiZaDozvoluSkladistaProps[];
}

export interface ExciseLicenceRequestListPayload {
  statusId: number | null;
  tipZahteva: number | null;
  datum: string | null | Dayjs;
  vrstaProizvoda: number | null;
  brojResenja: string | null;
  datumVazenja: string | null;
}
export interface ExciseLicenceRequestListResponse {
  exciseLicenceRequestList: ExciseLicenceRequest[];
  productTypes: DefaultOptionType[];
  requestTypes: DefaultOptionType[];
  statuses: DefaultOptionType[];
}

export interface ExciseLicenceRequest {
  id: number | null;
  brojZahteva: string;
  datumZahteva: string;
  tipZahteva: string;
  brojResenja: string;
  datumVazenja: string | null;
  statusZahteva: string;
}

export interface ISviZahteviZaDozvoluProps {
  zahteviZaAkciznuDozvolu: ExciseLicenceRequest[];
  filteriZaStatus: FilterSelectOption[];
  vrsteFilters: FilterSelectOption[];
  tipZahtevaFilters: FilterSelectOption[];
}

export interface ExciseLicencesState {
  //Response for /inicijalniPodaciDozvoleDrustva
  tipDozvole: DozvolaTipObjekta | null;

  kategorijaProizvoda: IKategorijeProizvodaProps[];

  //Response for /vracanjeDodatnihInformacijaZaKreiranjeDozvole

  dozvolaInformacijeSkladista: IDozvolaInformacijeSkladistaProps;
  userInformationDozvola: IUserInformationDozvolaProps;
  skladisteInformacije: ISkladisteInformacijeProps[];
  mereVelicine: IMereVelicineProps[];
  dokumentiZaDozvoluSkladista: IDokumentiZaDozvoluSkladistaProps[];

  //Response for /kreiranjeZahtevaDozvole

  data: number | null;

  //Payload for /kreiranjeZahtevaDozvole

  dokumentiZaDozvolu: IDokumentZaDozvoluForFilter[];
  dozvolaInformacije: IDozvolaInformacijeProps;
  skladisteInformacijePayload: ISkladisteInformacijeProps;

  //Selected
  selectedDozvolaId: number | null;
  selectedSkladisteId: number | null;
}

export type UpdateLicencesFunction = (
  updatedState: Partial<ExciseLicencesState>
) => void;

export type UpdateInformationLicenceFunction = (
  updatedState: Partial<IDozvolaInformacijeProps>
) => void;

export type UpdateInformationWarehouseFunction = (
  updatedState: Partial<ISkladisteInformacijeProps>
) => void;

export enum DozvolaTipObjekta {
  SKLADISTE = 1,
  PROIZVODNJA_SA_SKLADISTEM,
}
